import NavigationBarHeading from '@/components/Common/DesignSystem/NavigationBar/Heading/NavigationBarHeading';
import { GlobalStoreCtx } from '@/stores/GlobalStore';
import { EN_APP_DEVICE } from '@/utils/functions/device';
import React, { useContext } from 'react';

import styles from './NavigationBarHeadingFullCenter.module.scss';

type NavigationBarHeadingChild =
  | string
  | {
      title: string;
      subs: readonly string[];
    };

interface INavigationBarHeadingProps {
  /** 기본값 h1. 문맥 상 <h1>이 이상할 때 사용. */
  as?: 'h1' | 'p';
  children: NavigationBarHeadingChild;
}

/**
 * 내비게이션 바에 맞춰 스타일을 적용한 페이지 제목. 부제목을 받을 수 있다.
 */
const NavigationBarHeadingFullCenter: React.FC<INavigationBarHeadingProps> = ({ as = 'h1', children }) => {
  const globalStore = useContext(GlobalStoreCtx);
  const isAndroid = globalStore.AppDevice === EN_APP_DEVICE.ANDROID;
  const wrapper = !isAndroid ? styles.center : '';
  return (
    <div className={wrapper}>
      <NavigationBarHeading as={as} left={isAndroid}>
        {children}
      </NavigationBarHeading>
    </div>
  );
};

export default NavigationBarHeadingFullCenter;
